import type { Lang } from "../types";

export type I18nKey = keyof (typeof DICT)["de"];

export const DICT = {
  de: {
    loadingData: "Lade Daten…",
    spotsOnMap: "Spots auf Karte",
    spotsTotal: "insgesamt",
    scrapedAt: "geladen",
    countOf: "von",
    spotsLabel: "Spots",
    date: "Datum",
    species: "Fischart",
    allSpecies: "Alle Arten",
    methods: "Köder / Methode",
    allMethods: "Alle",
    sources: "Quellen",
    searchPlaceholder: "Gewässer suchen…",
    filters: "Filter",
    toggleFilters: "Filter umschalten",
    noMatches: "Keine Treffer",
    onlyInSeason: "Nur Spots in Saison am gewählten Tag",
    reset: "Zurücksetzen",
    close: "Schließen",
    clearDate: "Auf heute zurücksetzen",
    backToMap: "Zurück zur Karte",
    apply: "Anwenden",
    settings: "Einstellungen",
    language: "Sprache",
    currency: "Währung",
    installApp: "App installieren",
    installHintIos: "Tippe auf »Teilen« und »Zum Home-Bildschirm«",
    resetNorth: "Nach Norden ausrichten",
    creditFooter:
      "Daten automatisch übernommen von svfr.is, veidikortid.is, lax-a.is, strengir.is, fishpartner.is, fluguveidi.is. Preise ohne Gewähr — bitte beim Anbieter bestätigen.",
    statPrice: "Preis",
    freeBadge: "GRATIS",
    freeSourceLabel: "Gratis-Gewässer",
    secFishSpecies: "Fischarten",
    secAllowedBait: "Erlaubte Köder",
    secKeyFacts: "Eckdaten",
    secDescription: "Beschreibung",
    secResources: "Karten & Ressourcen",
    secPhotos: "Fotos",
    photosFrom: "Fotos von",
    photoError: "Bild konnte nicht geladen werden",
    photoRetry: "Erneut versuchen",
    factSeason: "Saison",
    factHours: "Tageszeit",
    factRodCount: "Anzahl Ruten",
    factInSeason: "in Saison",
    factOutOfSeason: "nicht in Saison",
    perRodDay: "/ Rute / Tag",
    perRodHalfDay: "/ Rute / halber Tag",
    perDay: "/ Tag",
    perSeason: "/ Saison",
    perCardYear: "(Jahreskarte)",
    perYear: "/ Jahr",
    priceUnknown: "kein Tagespreis bekannt",
    sourceLink: "Quelle",
    openInMaps: "In Google Maps öffnen",
    cardYearLabel: "Jahreskarte",
    cardYearShort: "Jahreskarte",
    fpMembershipShort: "FP Veiðifélagar (Jahr)",
    seasonNotInSeason: "nicht in Saison",
    spcSalmon: "Lachs",
    spcCharS: "Saibling",
    spcBrownTrout: "Bachforelle",
    spcSeaTrout: "Meerforelle",
    spcRainbow: "Regenbogenforelle",
    mthFly: "Fliege",
    mthSpinner: "Spinner",
    mthWorm: "Wurm",
    mthBait: "Köder",
    mthLure: "Lure",
    resMap: "Angelplatz-Karte",
    resDirections: "Wegbeschreibung",
    resReport: "Jahresbericht",
    resCounter: "Fischzähler",
    basemapStreets: "Karte",
    basemapSatellite: "Satellit",
    menu: "Menü",
    navHome: "Start",
    navMap: "Karte",
    navBlog: "Blog",
    navImpressum: "Impressum",
    homeHeroTitle: "Alle Fischerei-Reviere Islands an einem Ort",
    homeHeroLead:
      "Ein Hobbyprojekt aus Liebe zu Island: Ich sammle öffentlich zugängliche Infos zu Preisen, Saison und Lizenzen aller mir bekannten Anbieter — damit du nicht wie ich vier Reisen brauchst, um sie alle zu finden.",
    homeCtaMap: "Karte öffnen",
    homeCtaBlog: "Blog lesen",
    homeMotivationTitle: "Warum gibt es diese Seite?",
    homeMotivationBody1:
      "Ich liebe Island und das Fischen dort ist für mich jedes Mal ein Erlebnis. Auf meinen ersten Reisen kannte ich nur Veiðikortið — und war begeistert davon, mit einer einzigen Jahreskarte so viele Seen über die ganze Insel hinweg zu befischen.",
    homeMotivationBody2:
      "Erst auf meiner vierten Reise habe ich entdeckt, wie viele andere Anbieter es gibt: Strengir, Lax-á, Fish Partner, Fluguveiði und mehr. Aus den Recherchen ist diese Seite entstanden — als kleines Dankeschön an alle, die diese Reviere pflegen, und damit andere schneller fündig werden.",
    homeMotivationBody3:
      "Diese Seite ist kein offizieller Aggregator, sondern ein Hobbyprojekt. Bitte beim jeweiligen Anbieter buchen und Angaben bestätigen.",
    homeGettingStartedTitle: "So fängst du an",
    homeGettingStartedStep1Title: "Karte öffnen",
    homeGettingStartedStep1Body:
      "Alle bekannten Reviere als farbige Marker — Farbe = Anbieter. Tippe einen Marker, um Preis, Saison und Quelle zu sehen.",
    homeGettingStartedStep2Title: "Suchen oder Filtern",
    homeGettingStartedStep2Body:
      "Auf Mobile: Lupen-Knopf unten rechts → tippe los, die Liste filtert live. Plus Filter für Fischart, Methode, Saison-Tag und Anbieter.",
    homeGettingStartedStep3Title: "Veiðikortið für den Einstieg",
    homeGettingStartedStep3Body:
      "Wenn du neu in Island bist: die Veiðikortið-Jahreskarte (ca. 9'900 ISK) öffnet dir auf einen Schlag rund 35 Gewässer über die ganze Insel. Im Blog erkläre ich, wie ich damit angefangen habe.",
    homeFeatureLiveTitle: "Gebündelt statt verstreut",
    homeFeatureLiveBody:
      "Daten aus svfr.is, veidikortid.is, lax-a.is, strengir.is, fishpartner.is und fluguveidi.is — regelmässig aktualisiert, aber bitte beim Anbieter bestätigen.",
    homeFeatureSpeciesTitle: "Alle Fischarten",
    homeFeatureSpeciesBody:
      "Lachs, Bachforelle, Saibling, Meerforelle, Regenbogen — du kannst nach Fischart, Methode und Saisonzeit filtern.",
    homeFeatureFreeTitle: "Gratis-Gewässer",
    homeFeatureFreeBody:
      "Reykjavík-Stadtseen und andere kostenlose Strecken sind als solche markiert — kein verstecktes Permit nötig.",
    homeStatsSpots: "Reviere",
    homeStatsSources: "Anbieter-Quellen",
    homeStatsFree: "Gratis-Gewässer",
    homeBlogTeaserTitle: "Aus dem Blog",
    homeBlogTeaserMore: "Alle Beiträge",
    homeFeedbackTitle: "Fehler gesehen? Bitte sag Bescheid",
    homeFeedbackBody:
      "Preise und Saisonzeiten ändern sich. Wenn dir etwas Falsches oder Veraltetes auffällt, schreib mir — ich pflege die Seite nebenher und freue mich über jeden Hinweis.",
    feedbackLink: "Feedback senden",
    blogTitle: "Blog",
    blogLead: "Notizen rund ums Fischen in Island — was ich gelernt habe und gerne weitergebe.",
    blogEmpty: "Noch keine Beiträge.",
    blogBack: "Zurück zum Blog",
    blogReadingTime: "Min. Lesezeit",
    impressumTitle: "Impressum",
    impressumLegalSection: "Verantwortlich für den Inhalt",
    impressumContactSection: "Kontakt",
    impressumDisclaimerSection: "Haftungsausschluss",
    impressumDisclaimerBody:
      "Diese Seite aggregiert öffentlich zugängliche Daten zu Lizenzen, Preisen und Verfügbarkeiten. Alle Angaben ohne Gewähr — bitte beim jeweiligen Anbieter bestätigen, bevor du dich auf eine Information verlässt. Markenzeichen gehören den jeweiligen Eigentümern.",
    impressumDataSection: "Datenquellen",
    impressumDataBody:
      "Daten stammen automatisiert von svfr.is, veidikortid.is, lax-a.is, strengir.is, fishpartner.is und fluguveidi.is.",
    notFoundTitle: "Seite nicht gefunden",
    notFoundLead: "Die angefragte Seite existiert nicht oder wurde verschoben.",
    notFoundHome: "Zur Startseite",
  },
  en: {
    loadingData: "Loading…",
    spotsOnMap: "spots on map",
    spotsTotal: "total",
    scrapedAt: "scraped",
    countOf: "of",
    spotsLabel: "spots",
    date: "Date",
    species: "Fish species",
    allSpecies: "All species",
    methods: "Bait / method",
    allMethods: "All",
    sources: "Sources",
    searchPlaceholder: "Search waters…",
    filters: "Filters",
    toggleFilters: "Toggle filters",
    noMatches: "No matches",
    onlyInSeason: "Only spots in season on selected day",
    reset: "Reset",
    close: "Close",
    clearDate: "Reset to today",
    backToMap: "Back to map",
    apply: "Apply",
    settings: "Settings",
    language: "Language",
    currency: "Currency",
    installApp: "Install app",
    installHintIos: "Tap Share and then Add to Home Screen",
    resetNorth: "Reset bearing to north",
    creditFooter:
      "Data automatically aggregated from svfr.is, veidikortid.is, lax-a.is, strengir.is, fishpartner.is, fluguveidi.is. Prices without warranty — please confirm with the provider.",
    statPrice: "Price",
    freeBadge: "FREE",
    freeSourceLabel: "Free public water",
    secFishSpecies: "Fish species",
    secAllowedBait: "Allowed bait",
    secKeyFacts: "Key facts",
    secDescription: "Description",
    secResources: "Maps & resources",
    secPhotos: "Photos",
    photosFrom: "Photos from",
    photoError: "Image failed to load",
    photoRetry: "Try again",
    factSeason: "Season",
    factHours: "Hours",
    factRodCount: "Rod count",
    factInSeason: "in season",
    factOutOfSeason: "off season",
    perRodDay: "/ rod / day",
    perRodHalfDay: "/ rod / half-day",
    perDay: "/ day",
    perSeason: "/ season",
    perCardYear: "(annual card)",
    perYear: "/ year",
    priceUnknown: "no daily price known",
    sourceLink: "Source",
    openInMaps: "Open in Google Maps",
    cardYearLabel: "Annual card",
    cardYearShort: "Annual card",
    fpMembershipShort: "FP Veiðifélagar (year)",
    seasonNotInSeason: "off season",
    spcSalmon: "Salmon",
    spcCharS: "Arctic char",
    spcBrownTrout: "Brown trout",
    spcSeaTrout: "Sea trout",
    spcRainbow: "Rainbow trout",
    mthFly: "Fly",
    mthSpinner: "Spinner",
    mthWorm: "Worm",
    mthBait: "Bait",
    mthLure: "Lure",
    resMap: "Fishing-place map",
    resDirections: "Directions",
    resReport: "Annual report",
    resCounter: "Fish counter",
    basemapStreets: "Map",
    basemapSatellite: "Satellite",
    menu: "Menu",
    navHome: "Home",
    navMap: "Map",
    navBlog: "Blog",
    navImpressum: "Imprint",
    homeHeroTitle: "Every fishing water in Iceland in one place",
    homeHeroLead:
      "A hobby project, born out of love for Iceland: I collect publicly available info on prices, season and licenses from every operator I know — so you don't need four trips like I did to discover them all.",
    homeCtaMap: "Open the map",
    homeCtaBlog: "Read the blog",
    homeMotivationTitle: "Why this site exists",
    homeMotivationBody1:
      "I love Iceland and fishing there is an experience every time. On my first trips I only knew Veiðikortið — and was thrilled that one yearly card opened up so many lakes across the entire island.",
    homeMotivationBody2:
      "Only on my fourth trip did I find out how many other operators exist: Strengir, Lax-á, Fish Partner, Fluguveiði and more. This site grew out of those research notes — a small thank-you to the operators who maintain these waters, and a head start for anyone else trying to find them.",
    homeMotivationBody3:
      "This is not an official aggregator, just a hobby project. Please book directly with each operator and confirm the details.",
    homeGettingStartedTitle: "Getting started",
    homeGettingStartedStep1Title: "Open the map",
    homeGettingStartedStep1Body:
      "Every known water as a coloured marker — colour = operator. Tap a marker to see price, season and source.",
    homeGettingStartedStep2Title: "Search or filter",
    homeGettingStartedStep2Body:
      "On mobile: tap the magnifier (bottom right) → start typing, the list filters live. Plus filters for species, method, season day and operator.",
    homeGettingStartedStep3Title: "Veiðikortið as a starting point",
    homeGettingStartedStep3Body:
      "New to Iceland? The Veiðikortið yearly card (~9,900 ISK) unlocks around 35 waters across the whole island in one go. Read the blog for how I got started.",
    homeFeatureLiveTitle: "Bundled, not scattered",
    homeFeatureLiveBody:
      "Data from svfr.is, veidikortid.is, lax-a.is, strengir.is, fishpartner.is and fluguveidi.is — refreshed regularly, but please confirm with the operator.",
    homeFeatureSpeciesTitle: "All species",
    homeFeatureSpeciesBody:
      "Salmon, brown trout, arctic char, sea trout, rainbow — filter by species, method and season.",
    homeFeatureFreeTitle: "Free waters",
    homeFeatureFreeBody:
      "Reykjavík city lakes and other free stretches are flagged as such — no hidden permits.",
    homeStatsSpots: "Waters",
    homeStatsSources: "Operator sources",
    homeStatsFree: "Free waters",
    homeBlogTeaserTitle: "From the blog",
    homeBlogTeaserMore: "All posts",
    homeFeedbackTitle: "Spotted something wrong? Let me know",
    homeFeedbackBody:
      "Prices and season times change. If anything looks wrong or outdated, drop me a line — I maintain this on the side and appreciate every pointer.",
    feedbackLink: "Send feedback",
    blogTitle: "Blog",
    blogLead: "Notes on fishing in Iceland — what I've learned, and what I'm happy to pass on.",
    blogEmpty: "No posts yet.",
    blogBack: "Back to the blog",
    blogReadingTime: "min read",
    impressumTitle: "Imprint",
    impressumLegalSection: "Responsible for the content",
    impressumContactSection: "Contact",
    impressumDisclaimerSection: "Disclaimer",
    impressumDisclaimerBody:
      "This site aggregates publicly available data on licenses, prices and availability. All information is provided without warranty — please confirm with the respective provider before relying on it. Trademarks belong to their respective owners.",
    impressumDataSection: "Data sources",
    impressumDataBody:
      "Data is automatically aggregated from svfr.is, veidikortid.is, lax-a.is, strengir.is, fishpartner.is and fluguveidi.is.",
    notFoundTitle: "Page not found",
    notFoundLead: "The requested page does not exist or has been moved.",
    notFoundHome: "Go home",
  },
  is: {
    loadingData: "Hleður…",
    spotsOnMap: "veiðisvæði á korti",
    spotsTotal: "alls",
    scrapedAt: "sótt",
    countOf: "af",
    spotsLabel: "veiðisvæði",
    date: "Dagsetning",
    species: "Fisktegund",
    allSpecies: "Allar tegundir",
    methods: "Agn / aðferð",
    allMethods: "Allt",
    sources: "Heimildir",
    searchPlaceholder: "Leita í veiðisvæðum…",
    filters: "Síur",
    toggleFilters: "Sýna/fela síur",
    noMatches: "Engar niðurstöður",
    onlyInSeason: "Aðeins veiðisvæði í tímabili á völdum degi",
    reset: "Endursetja",
    close: "Loka",
    clearDate: "Endursetja á í dag",
    backToMap: "Til baka á kortið",
    apply: "Staðfesta",
    settings: "Stillingar",
    language: "Tungumál",
    currency: "Gjaldmiðill",
    installApp: "Setja upp app",
    installHintIos: "Smelltu á Deila og Bæta við heimaskjá",
    resetNorth: "Endurstilla norður",
    creditFooter:
      "Gögn sjálfkrafa sótt af svfr.is, veidikortid.is, lax-a.is, strengir.is, fishpartner.is, fluguveidi.is. Verð án ábyrgðar — vinsamlega staðfestu hjá veitanda.",
    statPrice: "Verð",
    freeBadge: "ÓKEYPIS",
    freeSourceLabel: "Ókeypis veiðisvæði",
    secFishSpecies: "Fisktegundir",
    secAllowedBait: "Leyfilegt agn",
    secKeyFacts: "Helstu staðreyndir",
    secDescription: "Lýsing",
    secResources: "Kort og gögn",
    secPhotos: "Myndir",
    photosFrom: "Myndir frá",
    photoError: "Mynd hlóðst ekki",
    photoRetry: "Reyna aftur",
    factSeason: "Tímabil",
    factHours: "Veiðitími",
    factRodCount: "Fjöldi stanga",
    factInSeason: "á tímabili",
    factOutOfSeason: "utan tímabils",
    perRodDay: "/ stöng / dag",
    perRodHalfDay: "/ stöng / hálfan dag",
    perDay: "/ dag",
    perSeason: "/ tímabil",
    perCardYear: "(ársskírteini)",
    perYear: "/ ár",
    priceUnknown: "ekkert dagverð þekkt",
    sourceLink: "Heimild",
    openInMaps: "Opna í Google Maps",
    cardYearLabel: "Ársskírteini",
    cardYearShort: "Ársskírteini",
    fpMembershipShort: "FP Veiðifélagar (árið)",
    seasonNotInSeason: "utan tímabils",
    spcSalmon: "lax",
    spcCharS: "bleikja",
    spcBrownTrout: "urriði",
    spcSeaTrout: "sjóbirtingur",
    spcRainbow: "regnbogasilungur",
    mthFly: "fluga",
    mthSpinner: "spúnn",
    mthWorm: "maðkur",
    mthBait: "beita",
    mthLure: "agn",
    resMap: "Veiðistaðakort",
    resDirections: "Leiðarlýsing",
    resReport: "Árnefndarskýrsla",
    resCounter: "Teljarinn",
    basemapStreets: "Kort",
    basemapSatellite: "Gervihnöttur",
    menu: "Valmynd",
    navHome: "Heim",
    navMap: "Kort",
    navBlog: "Blogg",
    navImpressum: "Útgáfa",
    homeHeroTitle: "Öll veiðisvæði Íslands á einum stað",
    homeHeroLead:
      "Áhugamannaverkefni úr ást á Íslandi: Ég safna saman opinberum upplýsingum um verð, tímabil og leyfi frá öllum þeim veitendum sem ég þekki — svo þú þurfir ekki að fara fjórar ferðir eins og ég til að finna þá alla.",
    homeCtaMap: "Opna kortið",
    homeCtaBlog: "Lesa bloggið",
    homeMotivationTitle: "Af hverju er þessi síða til?",
    homeMotivationBody1:
      "Ég elska Ísland og veiðin þar er einstök upplifun í hvert sinn. Á fyrstu ferðunum mínum þekkti ég bara Veiðikortið — og hreifst af því að geta veitt í svo mörgum vötnum víðs vegar um landið með einu árskorti.",
    homeMotivationBody2:
      "Það var ekki fyrr en í fjórðu ferðinni að ég komst að því hve margir aðrir veitendur eru: Strengir, Lax-á, Fish Partner, Fluguveiði og fleiri. Þessi síða spratt upp úr þeim rannsóknum — sem lítið þakklæti til þeirra sem viðhalda þessum svæðum, og fyrir aðra sem leita.",
    homeMotivationBody3:
      "Þetta er ekki opinber söfnunarsíða heldur áhugamannaverkefni. Vinsamlega bókaðu beint hjá hverjum veitanda og staðfestu upplýsingar.",
    homeGettingStartedTitle: "Hvar á að byrja",
    homeGettingStartedStep1Title: "Opnaðu kortið",
    homeGettingStartedStep1Body:
      "Öll þekkt svæði sem litaðir merkir — litur = veitandi. Smelltu á merki til að sjá verð, tímabil og heimild.",
    homeGettingStartedStep2Title: "Leitaðu eða síaðu",
    homeGettingStartedStep2Body:
      "Í síma: smelltu á stækkunarglerið niðri til hægri → byrjaðu að skrifa, listinn síast strax. Plús síur fyrir tegund, aðferð, tímabilsdag og veitanda.",
    homeGettingStartedStep3Title: "Veiðikortið sem byrjun",
    homeGettingStartedStep3Body:
      "Ný í Íslandi? Veiðikortið árskortið (um 9.900 ISK) opnar um 35 vötn um allt land á einu bretti. Á blogginu segi ég frá því hvernig ég byrjaði.",
    homeFeatureLiveTitle: "Allt á einum stað",
    homeFeatureLiveBody:
      "Gögn frá svfr.is, veidikortid.is, lax-a.is, strengir.is, fishpartner.is og fluguveidi.is — uppfærð reglulega, en vinsamlega staðfestu hjá veitanda.",
    homeFeatureSpeciesTitle: "Allar tegundir",
    homeFeatureSpeciesBody:
      "Lax, urriði, bleikja, sjóbirtingur, regnbogi — síaðu eftir tegund, aðferð og tímabili.",
    homeFeatureFreeTitle: "Ókeypis svæði",
    homeFeatureFreeBody:
      "Reykjavíkurvötn og fleiri ókeypis svæði eru merkt sérstaklega — engin falin leyfi.",
    homeStatsSpots: "Veiðisvæði",
    homeStatsSources: "Heimildir",
    homeStatsFree: "Ókeypis svæði",
    homeBlogTeaserTitle: "Úr blogginu",
    homeBlogTeaserMore: "Allar færslur",
    homeFeedbackTitle: "Sástu eitthvað rangt? Láttu mig vita",
    homeFeedbackBody:
      "Verð og tímabil breytast. Ef eitthvað er rangt eða úrelt, hafðu samband — ég sé um þetta í frítíma og þakka fyrir hverja ábendingu.",
    feedbackLink: "Senda ábendingu",
    blogTitle: "Blogg",
    blogLead: "Glósur um veiði á Íslandi — það sem ég hef lært og deili gjarnan.",
    blogEmpty: "Engar færslur enn.",
    blogBack: "Aftur á blogg",
    blogReadingTime: "mín. lestur",
    impressumTitle: "Útgáfa",
    impressumLegalSection: "Ábyrgð á efni",
    impressumContactSection: "Tengiliður",
    impressumDisclaimerSection: "Fyrirvari",
    impressumDisclaimerBody:
      "Þessi síða safnar saman opinberum upplýsingum um leyfi, verð og lausar stangir. Allar upplýsingar eru án ábyrgðar — vinsamlega staðfestu hjá viðkomandi veitanda áður en þú treystir á þær. Vörumerki eru eign viðkomandi eigenda.",
    impressumDataSection: "Heimildir",
    impressumDataBody:
      "Gögn eru sótt sjálfkrafa frá svfr.is, veidikortid.is, lax-a.is, strengir.is, fishpartner.is og fluguveidi.is.",
    notFoundTitle: "Síða fannst ekki",
    notFoundLead: "Umbeðin síða er ekki til eða hefur verið færð.",
    notFoundHome: "Á forsíðu",
  },
} satisfies Record<Lang, Record<string, string>>;

export type Dictionary = (typeof DICT)["de"];
